import styled from "styled-components";

/**
 * Wrapper principal do carrossel (Desktop)
 */
export const CarouselWrapperDesktop = styled.div`
  padding: ${({ theme }) => theme.spacing(2)} ${({ theme }) => theme.spacing(8)};
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;
  position: relative;
  display: flex;
  width: 100%;
`;

/**
 * Wrapper dos cartões do carrossel
 */
export const CardsWrapperDesktop = styled.div`
  padding-bottom: ${({ theme }) => theme.spacing(4)};
  overflow: hidden;
  display: flex;
  width: 100%;
`;

/**
 * Track dos itens do carrossel
 */
export const TrackDesktop = styled.div<{ offset: number }>`
  transform: ${({ offset }) => `translateX(-${offset}px)`};
  gap: ${({ theme }) => theme.spacing(2.25)};
  transition: transform 0.5s ease-in-out;
  will-change: transform;
  align-items: center;
  display: flex;
`;

/**
 * Botão de navegação (Comum)
 */
export const NavigationButtonDesktop = styled.button`
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadows.light.medium};
  width: ${({ theme }) => theme.spacing(6.5)};
  height: ${({ theme }) => theme.spacing(6.5)};
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 60%;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  z-index: 2;
  transform: translateY(-50%);
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.lightGray};
  }
`;

/**
 * Botão de navegação anterior
 */
export const PrevButtonDesktop = styled(NavigationButtonDesktop)`
  left: ${({ theme }) => theme.spacing(1)};
`;

/**
 * Botão de navegação próximo
 */
export const NextButtonDesktop = styled(NavigationButtonDesktop)`
  right: ${({ theme }) => theme.spacing(1)};
`;
